<template>
  <div class="certification-summary">
    <CollapsibleSection
      :inverted="showingDetails === true"
      :isVisible="showingDetails"
      @toggle="showingDetails = !showingDetails"
    >
      <template #toggle>
        <button
          type="button"
          class="link-styled-button text-underline"
          :aria-expanded="showingDetails ? 'true' : 'false'"
          aria-controls="certification-details"
          @click.prevent="showingDetails = !showingDetails"
        >
          {{ showingDetails ? "Hide" : "View" }} Details
        </button>
      </template>
      <div class="certification-details" v-show="showingDetails" id="certification-details">
        <div class="certification-detail-section">
          <div class="certification-detail">
            <span>School:&nbsp;</span>
            <span class="fw-700">{{ schoolName }}</span>
          </div>
          <div class="certification-detail">
            <span>Fund Requested Amount:&nbsp;</span>
            <span class="fw-700">{{ requestedAmount }}</span>
          </div>
          <div class="certification-detail">
            <span>Funding Term:&nbsp;</span>
            <span class="fw-700">{{ enrollmentTerm }}</span>
          </div>
        </div>
        <div class="certification-detail-section">
          <div class="certification-detail">
            <span>Status Last Updated:&nbsp;</span>
            <span class="fw-700">{{ statusLastUpdated }}</span>
          </div>
        </div>
      </div>
    </CollapsibleSection>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import CollapsibleSection from "@/components/transitions/CollapsibleSection.vue";

const props = defineProps<{
  enrollmentTerm: string;
  requestedAmount: string;
  schoolName: string;
  statusLastUpdated: string;
}>();

const showingDetails = ref<boolean>(false);

function toggleDetails(flag: boolean) {
  showingDetails.value = flag;
}

defineExpose({
  showingDetails,
  toggleDetails,
});
</script>
<style scoped src="@/styles/certification-updates/base.css"></style>
